const FORM_NAMES = {
    VOYAGES: 'Voyages',
    PORT_CALL_DETAILS: 'Port Call Details',
    CONFIRM_PORT_CALL: 'Confirm and Activate',
    DPG: 'DPG',
    CARGO: 'Cargo',
    SHIP_STORES: 'Ship Stores',
    CREW: 'Crew',
    PAX: 'Pax',
    SECURITY: 'Security'
};

export { FORM_NAMES };



// WEBPACK FOOTER //
// ./src/app/shared/constants/form-names.ts